<div class="login-wrapper">
  <div class="left-section">
    <div class="login-container px-3 py-2">
      <div class="login-logo mt-2">
        <img src="public/kudo.png" class="main-logo" />
      </div>
      <div class="main-title">
        <h2 class="title fw-bold" *ngIf="viewMode === 'login'">Login to MMA Tournament</h2>
        <h2 class="title fw-bold" *ngIf="viewMode === 'forgot_password_email'">Forgot Password</h2>
        <h2 class="title fw-bold" *ngIf="viewMode === 'forgot_password_otp'">OTP Verification</h2>
        <h2 class="title fw-bold" *ngIf="viewMode === 'forgot_password_reset'">Reset Password</h2>

        <p class="subtitle-text text-dark fw-bold" *ngIf="viewMode === 'login'">
          Organize and see everything at the one place, with live interaction and detailed dashboard.
        </p>
        <p class="subtitle-text text-dark fw-bold" *ngIf="viewMode === 'forgot_password_email'">
          Enter your registered email address. We will send an OTP to reset your password.
        </p>
        <p class="subtitle-text text-dark fw-bold" *ngIf="viewMode === 'forgot_password_otp'">
          We've sent a 6-digit verification code to <b class="text-danger fs-14">{{ forgotPasswordData.email }}</b>
          <br> Please enter it below to continue.
        </p>
        <p class="subtitle-text text-dark fw-bold" *ngIf="viewMode === 'forgot_password_reset'">
          Enter your new password to reset it.
        </p>
      </div>
      <!-- Login View -->
      <form class="login-box mt-4" (ngSubmit)="onLogin()" autocomplete="off" *ngIf="viewMode === 'login'">
        <div class="col-lg-12 col-md-12 mb-3">
          <div class="--input-group">
            <input type="text" name="email" placeholder="Username or Email" [(ngModel)]="LoginData.email"
              autocomplete="off" />
            <label class="form-label fs-12 fw-bold" Asterisk>Username or Email</label>
          </div>
        </div>
        <div class="col-lg-12 col-md-12">
          <div class="--input-group password-wrapper">
            <input [type]="showPassword ? 'text' : 'password'" name="password" placeholder="Password"
              [(ngModel)]="LoginData.password" autocomplete="off" />

            <label class="form-label fs-12 fw-bold" Asterisk>Password</label>

            <span class="toggle-password" (click)="togglePassword()">
              <i class="material-icons">
                {{ showPassword ? 'visibility_off' : 'visibility' }}
              </i>
            </span>
          </div>
          <div class="d-flex justify-content-end mb-3">
            <a href="javascript:void(0)" class="forgot-password-link" (click)="switchToForgotPassword()">Forgot
              Password?</a>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 mt-3">
          <button type="submit" class="login-btn fs-14 mb-3" [disabled]="loaderService.loading()">
            {{ loaderService.loading() ? 'Verifying...' : 'Sign In' }}
          </button>

          <div class="divider-container">
            <hr class="divider-line">
            <span class="divider-text">OR</span>
          </div>

          <a routerLink="/dashboard" target="_blank"
            class="login-btn live-score-btn fs-14 d-flex justify-content-center align-items-center text-decoration-none">
            <span class="material-icons" style="font-size: 18px; margin-right: 6px;">sports_martial_arts</span>
            View Live Score
          </a>
        </div>
      </form>

      <!-- Forgot Password - Email View -->
      <form class="login-box mt-4" (ngSubmit)="onSendOtp()" autocomplete="off"
        *ngIf="viewMode === 'forgot_password_email'">
        <div class="col-lg-12 col-md-12 mb-3">
          <div class="--input-group">
            <input type="text" name="forgot_email" placeholder="Registered Email" [(ngModel)]="forgotPasswordData.email"
              autocomplete="off" />
            <label class="form-label fs-12 fw-bold" Asterisk>Registered Email</label>
          </div>
        </div>

        <div class="col-lg-12 col-md-12 mt-3">
          <button type="submit" class="login-btn fs-14 mb-3" [disabled]="loaderService.loading()">
            {{ loaderService.loading() ? 'Sending OTP...' : 'Send OTP' }}
          </button>

          <div class="d-flex justify-content-center mb-3">
            <a href="javascript:void(0)" class="forgot-password-link" (click)="switchToLogin()">Back to Login</a>
          </div>
        </div>
      </form>

      <!-- Forgot Password - OTP View -->
      <form class="login-box mt-4" (ngSubmit)="onVerifyOtpStep()" autocomplete="off"
        *ngIf="viewMode === 'forgot_password_otp'">
        <div class="col-lg-12 col-md-12 mb-4">
          <label class="form-label fs-14 fw-bold d-block mb-3" Asterisk>Enter 6-digit OTP</label>
          <div class="d-flex gap-2 otp-container">
            <input *ngFor="let digit of otpDigits; let i = index; trackBy: trackByIndex" type="text"
              class="form-control text-center fs-4 fw-bold" maxlength="1" [(ngModel)]="otpDigits[i]" [name]="'otp_' + i"
              [id]="'otp_' + i" (keyup)="onOtpInput($event, i)" (paste)="onOtpPaste($event)" autocomplete="off"
              style="width: 50px; height: 55px; border-radius: 8px;" />
          </div>
        </div>

        <div class="col-lg-12 col-md-12 mt-3">
          <button type="submit" class="login-btn fs-14 mb-3">
            Verify OTP
          </button>

          <div class="d-flex justify-content-between px-2 mb-3 align-items-center">
            <a href="javascript:void(0)" class="forgot-password-link" (click)="switchToLogin()">Cancel & Back to
              Login</a>

            <ng-container *ngIf="resendOtpTimer > 0">
              <span class="fs-12 fw-bold text-muted">Resend in {{ formatTime(resendOtpTimer) }}</span>
            </ng-container>
            <ng-container *ngIf="resendOtpTimer === 0">
              <a href="javascript:void(0)" class="forgot-password-link fw-bold" style="color: #ed1c24;"
                (click)="resendOtp()">Resend OTP</a>
            </ng-container>
          </div>
        </div>
      </form>

      <!-- Forgot Password - Reset View -->
      <form class="login-box mt-4" (ngSubmit)="onResetPassword()" autocomplete="off"
        *ngIf="viewMode === 'forgot_password_reset'">
        <div class="col-lg-12 col-md-12 mb-3">
          <div class="--input-group password-wrapper">
            <input [type]="showNewPassword ? 'text' : 'password'" name="newPassword" placeholder="New Password"
              [(ngModel)]="forgotPasswordData.newPassword" autocomplete="off" />
            <label class="form-label fs-12 fw-bold" Asterisk>New Password</label>
            <span class="toggle-password" (click)="toggleNewPassword()">
              <i class="material-icons">
                {{ showNewPassword ? 'visibility_off' : 'visibility' }}
              </i>
            </span>
          </div>
        </div>

        <div class="col-lg-12 col-md-12 mb-3">
          <div class="--input-group password-wrapper">
            <input [type]="showConfirmPassword ? 'text' : 'password'" name="confirmPassword"
              placeholder="Confirm Password" [(ngModel)]="forgotPasswordData.confirmPassword" autocomplete="off" />
            <label class="form-label fs-12 fw-bold" Asterisk>Confirm Password</label>
            <span class="toggle-password" (click)="toggleConfirmPassword()">
              <i class="material-icons">
                {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
              </i>
            </span>
          </div>
        </div>

        <div class="col-lg-12 col-md-12 mt-3">
          <button type="submit" class="login-btn fs-14 mb-3" [disabled]="loaderService.loading()">
            {{ loaderService.loading() ? 'Updating...' : 'Submit & Update Password' }}
          </button>

          <div class="d-flex justify-content-center mb-3">
            <a href="javascript:void(0)" class="forgot-password-link" (click)="switchToLogin()">Cancel & Back to
              Login</a>
          </div>
        </div>
      </form>
      <div class="footer-container">
        <div class="footer-copy text-center mt-4">
          <p class="mb-1 me-2">
            &copy; by
            <span class="fw-bold --text-red me-1"><a class="--text-red" target="_blank"
                href="https://responscity.com/">Responscity Systems</a></span>
          </p>
          <p class="mb-1 me-2">
            Support
            <span class="fw-bold --text-red me-1"><a class="--text-red"
                href="mailto:hello@responscity.com">hello@responscity.com</a></span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="right-section"></div>
</div>